import ConnectWallet from "../components/ConnectWallet";
import Menu from "../components/Menu";
import ScrollTop from "../components/ScrollTop";

export default function MarketplaceComing() {
  return (
    <div className="godlyContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <div className="pageTitle">Auction</div>
      <div className="comingSoon">Coming soon...</div>

      <div className="footer">
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
